import { IndexerPendingIndicator } from "./indexer-pending-indicator"

/**
 * Inline notice surfaced on every manage-position action (increase, decrease,
 * collect, burn) while the on-chain NFPM tokenId has not yet been discovered
 * for the active position. When this banner is visible the underlying store's
 * `canSubmit` returns `false` and `submit()` short-circuits with a matching
 * error — the notice exists purely to explain *why* the primary action is
 * disabled, turning an otherwise-silent wait into a reassuring status line.
 */
export const NfpmPendingNotice = ({ actionLabel }: { actionLabel: string }) => (
  <div
    role="status"
    aria-live="polite"
    className="flex items-start gap-2 rounded-md border border-amber-400/30 bg-amber-400/10 px-3 py-2 text-xs text-t200"
    data-testid="nfpm-pending-notice"
  >
    <IndexerPendingIndicator
      proposal="P4"
      size="xs"
      ariaLabel="NFP ID pending indexer Proposal 4"
    />
    <span>
      Resolving on-chain NFP id for this position — {actionLabel} will enable in a moment.
    </span>
  </div>
)
